import { useMemo } from 'react';
import { Share2, Trash2, Palette, SquarePen } from 'lucide-react';
import SelectionActionMenu from '../features/floorPlanEditor/FloorPlanWorkspace/SelectionActionMenu.jsx';
import { getDefaultFloorPlanBlockedBounds } from '../features/floorPlanEditor/FloorPlanWorkspace/useOverlayPlacement.js';

/**
 * @param {{
 *   anchor: { x: number; y: number };
 *   wallAngleDeg?: number;
 *   viewportRect?: { width: number; height: number } | null;
 *   onAddPoint: () => void;
 *   onEdit: () => void;
 *   onDelete: () => void;
 *   onChangeColor: () => void;
 *   onBoundsChange?: (bounds: { x: number; y: number; width: number; height: number; placement: string }) => void;
 * }} props
 */
function FloorPlanWallActions({
  anchor,
  viewportRect = null,
  onAddPoint,
  onEdit,
  onDelete,
  onChangeColor,
  onBoundsChange,
}) {
  const actions = useMemo(
    () => [
      { key: 'add', title: 'Add corner point', onClick: onAddPoint, Icon: Share2 },
      { key: 'edit', title: 'Edit wall', onClick: onEdit, Icon: SquarePen },
      { key: 'delete', title: 'Delete wall', onClick: onDelete, Icon: Trash2 },
      { key: 'color', title: 'Change material', onClick: onChangeColor, Icon: Palette },
    ],
    [onAddPoint, onEdit, onDelete, onChangeColor],
  );

  const blockedBounds = viewportRect
    ? getDefaultFloorPlanBlockedBounds(viewportRect.width, viewportRect.height)
    : [];

  return (
    <SelectionActionMenu
      anchor={anchor}
      actions={actions}
      canvasBounds={viewportRect}
      blockedBounds={blockedBounds}
      ariaLabel="Wall actions"
      onBoundsChange={onBoundsChange}
    />
  );
}

export default FloorPlanWallActions;
